"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectList = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const SimpleButton_1 = tslib_1.__importDefault(require("./SimpleButton"));
const SelectList = (props) => {
    return (React.createElement(React.Fragment, null, props.options.map((option) => (React.createElement(SimpleButton_1.default, { p: 2, width: '100%', variant: "text", onClick: () => props.onChange(option), key: option.label }, option.label)))));
};
exports.SelectList = SelectList;
